import { useRef } from 'react';
import Image from 'next/image';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';



const ServicesInfo = ({title, text, list, image, aftertext}) => {

  const sectionRef = useRef(null)
  const containerRef = useRef(null)
  const titleRef = useRef(null)
  const textRef = useRef(null)
  const imageWrapperRef = useRef(null)
  const listRef = useRef(null)

  useGSAP(()=> {

    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {

        gsap.fromTo(titleRef.current, { opacity: 0 }, {
          opacity: 1,
  
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 85%",
          },
        });

        gsap.fromTo(textRef.current, { opacity: 0 }, {
          opacity: 1,
  
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 85%",
          },
        });

        gsap.fromTo(listRef.current, { opacity: 0 }, {
          opacity: 1,
  
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 65%",
          },
        });

        gsap.fromTo(containerRef.current, {
          y: '14rem'
        },
           {
          y: 0,
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top bottom", 
            end: "top 60%",  
            scrub: 0.1,  
          },
        });



      })
  }, {scope: sectionRef});



  return (
    <section ref={sectionRef} className="container-max py-[4rem] container-padding  md:py-[5rem] lg:py-[6rem] xl:py-[8rem] w-full relative">
      <div ref={containerRef} className='flex-col  container-grid'>

        <h2 ref={titleRef} dangerouslySetInnerHTML={{__html: title}} className='heading-3 md:col-span-5 lg:text-right  lg:mb-4rem md:max-w-[60rem] lg:max-w-none [&>.selected]:italic [&>.selected]:text-dusty-blue-light mb-[1.6rem] md:mb-[2rem] lg:mb-[4rem]'/>

        <p ref={textRef} className='lg:mt-[0.8rem] xl:mt-[1.4rem] md:col-span-5 lg:col-span-6 xl:col-span-5 lg:col-start-7 xl:col-start-7 text-1 md:max-w-[60rem] lg:max-w-none lg:mb-4rem mb-[2.4rem] md:mb-[4rem]'>{text}</p>



      
        <div className='hidden md:flex flex-col lg:hidden lg:max-w-[50rem] xl:pr-0 lg:flex-col lg:justify-start lg:pt-[6rem] md:col-span-3 lg:col-span-5 lg:col-start-7 '>
          <ul className='flex flex-col gap-[1.6rem] mb-[2rem]'>
            {list?.map((item,index)=> <li key={index} className='pl-[2rem] text-1 relative'>
                <span className='absolute w-[0.5rem] bg-dark-blue h-[0.5rem] left-[0.5rem] top-[0.5rem]'></span>{item.text}
            </li>)}
          </ul>
          <p className='caption '>{aftertext}</p>
        </div>

        <div ref={imageWrapperRef} className='md:col-span-2 md:pl-[10%] md:col-start-4 lg:col-start-1 lg:col-span-5 w-full lg:pl-[26%] mx-[2rem] md:mx-0 mb-[2.1rem] md:mb-0'>
          <div  className="relative  w-full aspect-[1.46] ">
            <Image
              src={image?.url}
              alt={image?.alt}
              fill
              
              sizes="650px"
              className="w-auto object-cover"
            />
          </div>
        </div>

        <div ref={listRef} className='flex flex-col md:hidden lg:flex lg:max-w-[50rem] xl:pr-0 lg:flex-col lg:justify-start lg:pt-[6rem] md:col-span-2 lg:col-span-5 lg:col-start-7 '>
          <ul className='flex flex-col gap-[1.6rem] mb-[2rem]'>
            {list?.map((item,index)=> <li key={index} className='pl-[2rem] text-1 relative'>
                <span className='absolute w-[0.5rem] bg-dark-blue h-[0.5rem] left-[0.5rem] top-[0.5rem]'></span>{item.text}
            </li>)}
          </ul>
          <p className='caption '>{aftertext}</p>
        </div>


      </div>
    </section>
  );
};

export default ServicesInfo;